import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

// Images
import browsing_items_image from '../../utils/imgs/browsing_items_image.png';
import instant_message_image from '../../utils/imgs/instant_message_image.png';
import profile_icon_image from '../../utils/imgs/profile_icon_image.png';
import sell_dress_image from '../../utils/imgs/sell_dress_image.png';
import multi_race_people_image from '../../utils/imgs/multi_race_people_image.png';

// Displays if the user is logged in AND has set up profile
const HowItWorks = ({ 
    hide_title,
    nav: {
        website,
        website_loading
    }
}) => {

    // Render the component
    return (
        <div style={{padding: '16px', borderBottom: '1px solid #e6ecf0'}}>
            {!hide_title && (
                <div style={{color:'rgb(15, 20, 25)', marginBottom: '1.5rem', textAlign:'center', fontWeight:'700', fontSize:'24px', lineHeight:'24px', overflowWrap:'break-word'}}>
                    <span style={{fontSize: '1.125rem'}}>Welcome to {website?.short_name ? `${website.short_name}'s Buy / Sell Community!` : 'Buy Sell App'}</span>
                </div>
            )}
            
            <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                <div style={{minWidth: '5rem', border: '1px solid #e6ecf0', borderRadius: '.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '5rem', height: '5rem'}}>
                    <img style={{objectFit: 'contain', overflow: 'hidden', margin: 'auto', maxWidth: '80%', height: 'auto'}} src={browsing_items_image} />
                </div>
                <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                        Browse Tons of Great Items Nearby.
                    </h5>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                        like furniture, clothes, and electronics — and buy from {(website?.privacy?.toLowerCase() === 'students only') ? `your classmates` : 'people in your community'}.
                    </h5>
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                <div style={{minWidth: '5rem', border: '1px solid #e6ecf0', borderRadius: '.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '5rem', height: '5rem'}}>
                    <img style={{objectFit: 'contain', overflow: 'hidden', margin: 'auto', maxWidth: '70%', height: 'auto'}} src={instant_message_image} />
                </div>
                <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                        Instantly Message Sellers.
                    </h5>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                        securely on the website to negotiate price and set up a time to meet.
                    </h5>
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                <div style={{minWidth: '5rem', border: '1px solid #e6ecf0', borderRadius: '.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '5rem', height: '5rem'}}>
                    <img style={{objectFit: 'contain', overflow: 'hidden', margin: 'auto', maxWidth: '80%', height: 'auto'}} src={profile_icon_image} />
                </div>
                <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                        Check out people's profiles.
                    </h5>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                        to see who they are, and what they are selling.
                    </h5>
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                <div style={{minWidth: '5rem', border: '1px solid #e6ecf0', borderRadius: '.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '5rem', height: '5rem'}}>
                    <img style={{objectFit: 'contain', overflow: 'hidden', margin: 'auto', maxWidth: '80%', height: 'auto'}} src={sell_dress_image} />
                </div>
                <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                        Sell something of your own.
                    </h5>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                        by simply taking a picture with your phone. Posting takes less than 30 seconds!
                    </h5>
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                <div style={{minWidth: '5rem', border: '1px solid #e6ecf0', borderRadius: '.25rem', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '5rem', height: '5rem'}}>
                    <img style={{objectFit: 'contain', overflow: 'hidden', margin: 'auto', maxWidth: '80%', height: 'auto'}} src={multi_race_people_image} />
                </div>
                <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                        Join thousands of {(website?.privacy?.toLowerCase() === 'students only') ? `students` : 'people'}.
                    </h5>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                        on the {(website?.short_name && website?.privacy?.toLowerCase() === 'students only') ? `largest groupchat for students to buy and sell at ${website?.short_name}` : 'simplest platform to buy and sell'}.
                    </h5>
                </div>
            </div>
        </div>
    )
}

// Prop types for the component
HowItWorks.propTypes = {
    nav: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    nav: state.nav
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
})(HowItWorks);
